/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskDimensionLabelDetail } from './RiskDimensionLabelDetail';
import {
  RiskDimensionLabelDetailFromJSON,
  RiskDimensionLabelDetailFromJSONTyped,
  RiskDimensionLabelDetailToJSON,
} from './RiskDimensionLabelDetail';

/**
 *
 * @export
 * @interface PaginatedRiskDimensionLabelDetailList
 */
export interface PaginatedRiskDimensionLabelDetailList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskDimensionLabelDetailList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskDimensionLabelDetailList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskDimensionLabelDetailList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RiskDimensionLabelDetail>}
   * @memberof PaginatedRiskDimensionLabelDetailList
   */
  results: Array<RiskDimensionLabelDetail>;
}

/**
 * Check if a given object implements the PaginatedRiskDimensionLabelDetailList interface.
 */
export function instanceOfPaginatedRiskDimensionLabelDetailList(
  value: object,
): value is PaginatedRiskDimensionLabelDetailList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskDimensionLabelDetailListFromJSON(json: any): PaginatedRiskDimensionLabelDetailList {
  return PaginatedRiskDimensionLabelDetailListFromJSONTyped(json, false);
}

export function PaginatedRiskDimensionLabelDetailListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRiskDimensionLabelDetailList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskDimensionLabelDetailFromJSON),
  };
}

export function PaginatedRiskDimensionLabelDetailListToJSON(value?: PaginatedRiskDimensionLabelDetailList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskDimensionLabelDetailToJSON),
  };
}
